/*
 * Copyright (c) 2018 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementDeleteCertificateController', MemberManagementDeleteCertificateController);

    MemberManagementDeleteCertificateController.$inject = ['$uibModalInstance', 'entity', 'MemberManagement'];

    function MemberManagementDeleteCertificateController($uibModalInstance, entity, MemberManagement) {
        var vm = this;

        vm.profile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete () {
            vm.profile.matriculationCertificateContentType = null;
            MemberManagement.update(vm.profile,
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
